import React, { type FC } from 'react'

import { useIntl } from 'react-intl'

import { TEXT_VARIANT_STANDARD, Text } from 'mailup-web-components'

const Intro: FC = () => {
  const intl = useIntl()

  return (
    <Text variant={TEXT_VARIANT_STANDARD}>
      {intl.formatMessage({ id: 'Load.GroupsOverlap.PageIntro' })}
    </Text>
  )
}

export default Intro
